// extracted by mini-css-extract-plugin
export default {"container":"Activity_container__3sKD9","userContainer":"Activity_userContainer__sMxbJ","avatar":"Activity_avatar__budWZ","p":"Activity_p__H5Uew"};